import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { updateGeoGuesser, getGeoGuesserAdminById } from '@/services/geoGuesser/geoGuesser.service';
import GeoGuesserForm from '@/components/Cms/GeoGuesserForm/GeoGuesserForm.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditGeoGuesser',
  setup(__props) {

const route = useRoute();

const geo = ref<any | null>(null);
const loading = ref(true);
const saving = ref(false);
const success = ref(false);
const errorMessage = ref('');

onMounted(async () => {
  try {
    geo.value = await getGeoGuesserAdminById(Number(route.params.id));
  } catch {
    errorMessage.value = 'Failed to load GeoGuesser.';
  } finally {
    loading.value = false;
  }
});

async function handleUpdate(payload: any) {
  saving.value = true;
  success.value = false;

  try {
    await updateGeoGuesser(Number(route.params.id), payload);
    success.value = true;
  } catch (err: any) {
    errorMessage.value = 'Failed to update GeoGuesser.';
  } finally {
    saving.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "fill-height d-flex align-center justify-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pa-6 w-100" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5 text-center mb-4" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Edit GeoGuesser", -1)
            ]))]),
            _: 1
          }),
          (loading.value)
            ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                key: 0,
                indeterminate: "",
                class: "mx-auto my-6"
              }))
            : (_openBlock(), _createBlock(GeoGuesserForm, {
                key: 1,
                initialData: geo.value,
                onSubmit: handleUpdate,
                loading: saving.value
              }, null, 8, ["initialData", "loading"])),
          (success.value)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 2,
                type: "success",
                variant: "tonal",
                class: "mt-4 text-center"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode(" GeoGuesser updated successfully. ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (errorMessage.value)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 3,
                type: "error",
                variant: "tonal",
                class: "mt-4 text-center"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(errorMessage.value), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})